// extracted by mini-css-extract-plugin
export var border = "_1c-7";
export var brand = "_1c-r";
export var button = "_1c-j";
export var center = "_1c-9";
export var centered = "_1c-5";
export var closeButton = "_1c-b";
export var disabledWrapper = "_1c-k";
export var error = "_1c-n";
export var extraLarge = "_1c-4";
export var extraSmall = "_1c-1";
export var fill = "_1c-g";
export var footer = "_1c-f";
export var footerAction = "_1c-h";
export var footerButtons = "_1c-i";
export var header = "_1c-6";
export var icon = "_1c-m";
export var info = "_1c-q";
export var inline = "_1c-8";
export var large = "_1c-3";
export var main = "_1c-c";
export var modal = "_1c-0";
export var neutral = "_1c-s";
export var noPadding = "_1c-e";
export var none = "_1c-t";
export var scrollable = "_1c-d";
export var small = "_1c-2";
export var success = "_1c-p";
export var tight = "_1c-l";
export var titleIcon = "_1c-a";
export var warn = "_1c-o";